module.exports = "<div class=\"modal-header\" ng-if=\"vm.title\">\n    <h3 class=\"modal-title\" id=\"modal-title\">{{vm.title}}</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" ng-bind-html=\"vm.message\">\n</div>\n<div class=\"modal-footer\">\n    <button class=\"btn btn-danger\" type=\"button\" ng-click=\"vm.ok()\">{{ 'yes' | translate }}</button>\n    <button class=\"btn btn-warning\" type=\"button\" ng-click=\"vm.cancel()\">{{ 'no' | translate }}</button>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/stModal/stModal.html
// module id = 132
// module chunks = 0